import { useEffect, useState } from "react";

export type ChromeHeights = {
  /** The announcement bar above the nav; 0 when it isn't shown. */
  banner: number;
  /** The nav itself. */
  header: number;
};

/**
 * The site chrome's live heights, for the visual zone that pins beneath it.
 * Null until measured; the zone's CSS carries per-breakpoint fallbacks that
 * match, so the first paint doesn't shift when these arrive.
 */
export const useChromeHeights = (): ChromeHeights | null => {
  const [heights, setHeights] = useState<ChromeHeights | null>(null);

  useEffect(() => {
    const chrome = document.querySelector("[data-site-chrome]");
    if (!(chrome instanceof HTMLElement)) return;

    const measure = () => {
      const parts = [...chrome.children].map(
        (child) => child.getBoundingClientRect().height,
      );
      // The nav is always last; anything before it is the announcement.
      const header = parts.at(-1) ?? 0;
      const total = chrome.getBoundingClientRect().height;
      setHeights({
        banner: Math.round(total - header),
        header: Math.round(header),
      });
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(chrome);
    return () => observer.disconnect();
  }, []);

  return heights;
};
